// extracted by mini-css-extract-plugin
export default {"root":"IconButton_root__80xkD"};